<template>
  <div class="bicycleUnused">
    <!-- <header-bar></header-bar> -->
  <div class="unBListheader">

  <div class="unBListsel">
     {{$t('message.partner')}}：
           <!-- <select-menu :partData="partData" @change="changeHandler"></select-menu> -->
            <el-select v-model="valuePa" placeholder="请选择" @change="changeHandler" class="selectCss" filterable>
            <el-option
             v-for="item in partData"
             :key="item.partnerNo"
             :label="item.loginName"
             :value="item.partnerNo">
            </el-option>
          </el-select>
          {{$t('message.area')}}：
          <!-- <select-men :areaData="areaData" @change="changeArea"></select-men> -->
           <el-select v-model="valueAr" placeholder="请选择" @change="changeArea" class="selectCss" filterable>
           <el-option
            v-for="item in areaData"
            :key="item.partnerareaguid"
            :label="item.Partnerareaname"
            :value="item.partnerareaguid">
          </el-option>
         </el-select>
          <el-dropdown @command="userOperation" class="dropName">
                        <span class="user">{{this.$cookies.get("LoginName")}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                        <el-dropdown-menu slot="dropdown" class="dropst">
                            <el-dropdown-item command="editPsd">{{$t('message.changePSD')}}</el-dropdown-item>
                             <!-- <el-dropdown-item command="editSecPsd">{{$t('message.changeSecPSD')}}</el-dropdown-item> -->
                            <el-dropdown-item command="logout">{{$t('message.exit')}}</el-dropdown-item>
                        </el-dropdown-menu>
            </el-dropdown>
        </div>
        <lang-select class="drops" @handIt="loadAgain"></lang-select>
    </div>
    <div class="unBListmain">
                      <div class="unBLHead">
                        {{$t('message.xdayNouse')}}
                        <el-input v-model="bikeDay" :placeholder="$t('message.enterDay')" class="unlistIn"></el-input>
                          <el-button type="primary" 
                          class="fsearch"
                        @click="searchUnList()"
                          icon="el-icon-search">
                          </el-button>
                        </div>
                        <div class="listTable">
                            <el-table
                               :data="unlistData"
                               v-loading="unloading"
                               style="width: 100%"
                                >
                             <el-table-column
                               type="index" 
                               :label="$t('message.orderNum')"
                             >
                             </el-table-column>
                             <el-table-column
                                prop="BicycleNo"
                                :label="$t('message.bikeNo')"
                                >
                              </el-table-column>
                             <el-table-column
                                prop="PartnerAreaName"
                                :label="$t('message.operationArea')"
                                >
                              </el-table-column>
                              <el-table-column
                                prop="Battery"
                                :label="$t('message.syEnergy')"
                                >
                              </el-table-column>
                              <el-table-column
                                 prop="NoUseDays"
                                 sortable
                                :label="$t('message.xdayNouse')"
                                >
                              </el-table-column>
                              <el-table-column
                                  prop="ReplaceBatteryTime"
                                :label="$t('message.lastCHangT')"
                                >
                              </el-table-column>
                              <el-table-column
                                prop="LastBackTime"
                                :label="$t('message.lastUserR')"
                                >
                              </el-table-column>
                               <el-table-column
                                :label="$t('message.location')"
                                >
                                 <template scope="scope">
                                  <div>
                                    <el-button type="primary" @click="showMap(scope.row.Coordinates,scope.row.BicycleNo)">{{$t('message.view')}}</el-button>
                                     <!-- <el-button type="primary" @click="viewLog(scope.row.BicycleNo)">{{$t('message.view')}}</el-button> -->
                                  </div>
                                </template>
                              </el-table-column>
                               
                             </el-table>
                           
                        </div>
     </div>
      <el-dialog
      :title="$t('message.changePSD')"
      :visible.sync="editPSDS"
      width="24%"
      >
      <el-form ref="form" :model="formm" label-width="80px">
       <el-form-item :label="$t('message.oldPSD')">
        <el-input v-model="formm.oldpsd" type="password"></el-input>
       </el-form-item>
        <el-form-item :label="$t('message.newPSD')">
        <el-input v-model="formm.newpsd" type="password"></el-input>
       </el-form-item>
        <el-form-item :label="$t('message.suerPSD')">
        <el-input v-model="formm.surepsd" type="password"></el-input>
       </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="editPSDS = false">{{$t('message.cancels')}}</el-button>
      <el-button type="primary" @click="changePsds">{{$t('message.sure')}}</el-button>
      </span>
     </el-dialog>

      <el-dialog
      :title="$t('message.changeSecPSD')"
      :visible.sync="editSecPSDS"
      width="26%"
      >
      <el-form ref="form" :model="formmSec" label-width="100px">
       <el-form-item :label="$t('message.oldSecPsd')">
        <el-input v-model="formmSec.oldpsd" type="password"></el-input>
       </el-form-item>
        <el-form-item :label="$t('message.newSecPsd')">
        <el-input v-model="formmSec.newpsd" type="password"></el-input>
       </el-form-item>
        <el-form-item :label="$t('message.suerSecPsd')">
        <el-input v-model="formmSec.surepsd" type="password"></el-input>
       </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="editSecPSDS = false">{{$t('message.cancels')}}</el-button>
      <el-button type="primary" @click="changeSecPsds">{{$t('message.sure')}}</el-button>
      </span>
     </el-dialog>

     <!-- 地图弹窗 -->
      <el-dialog
      :title="$t('message.location')"
      :visible.sync="mapVb"
      width="54%"
      >
     <div class="maps">
          <el-button type="primary" @click="viewLog(logBike)" class="logBtn">{{$t('message.viewLog')}}</el-button>
         <el-amap class="amap-box" :vid="'amap-vue'" :zoom="zoom" :amap-manager="amapManager" :plugin="plugin">
          <el-amap-info-window
          :position="currentWindow.position"
          :content="currentWindow.content"
          :visible="currentWindow.visible"
          :events="currentWindow.events">
        </el-amap-info-window>        
         </el-amap>
      </div>
      <span slot="footer" class="dialog-footer">
      </span>
     </el-dialog>

      <el-dialog
        :title="$t('message.sysTit')"
        :visible.sync="dialogOuti"
        width="30%"
      >
       <span>{{soneIns}}</span>
       <span slot="footer" class="dialog-footer">
        <el-button @click="dialogOuti = false">{{$t('message.cancels')}}</el-button>
        <el-button type="primary" @click="logout">{{$t('message.sure')}}</el-button>
       </span>
      </el-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import md5 from "js-md5";
import SelectMenu from "@/components/SelectMenu.vue";
import SelectMen from "@/components/SelectMen.vue";
import LangSelect from "@/components/LangSelect.vue";
import { AMapManager } from "vue-amap";
let amapManager = new AMapManager();
var marker = "";
var OrderDesc = ""; //升序降序
export default {
  name: "BicycleUnused",
  data() {
    return {
      soneIns: "",
      dialogOuti: false,
      logBike: "",
      mapVb: false,
      amapManager,
      zoom: 18,
      plugin: ["ToolBar"],
      currentWindow: {
        position: [0, 0],
        content: "",
        events: {},
        visible: false
      },
      editSecPSDS: false,
      formmSec: {
        oldpsd: "",
        newpsd: "",
        surepsd: ""
      },
      valuePa: "",
      valueAr: "",
      editPSDS: false,
      formm: {
        oldpsd: "",
        newpsd: "",
        surepsd: ""
      },
      partData: "",
      areaData: "",
      bikeDay: "",
      unlistData: [],
      unloading: true
    };
  },
  created() {
    this.loadPartner();
  },
  updated() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    loadPartner() {
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("partnerno", this.$cookies.get("pno"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/PartnerRelated/BiNdiNg_PartneR",
        method: "post",
        data: params
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   }
      })
        .then(res => {
          if (res.data.status == "success") {
            this.partData = res.data.data;
            var partV = this.$cookies.get("partner");
            if (partV == null) {
              this.valuePa = this.partData[0].partnerNo;
            } else {
              this.valuePa = this.$cookies.get("partner");
            }
            this.$cookies.set("partner", this.valuePa);
            this.loadArea();
          } else if (res.data.status == "re_login") {
            this.soneIns = res.data.message;
            this.dialogOuti = true;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    loadArea() {
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerno", this.$cookies.get("partner"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/PartnerRelated/BiNdiNg_PartneR_aReA",
        method: "post",
        data: params,
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   },
        withCredentials: true
      })
        .then(res => {
          this.areaData = res.data.data;
          var areaV = this.$cookies.get("areaValue");

          if (areaV == null) {
            this.valueAr = this.areaData[0].partnerareaguid;
          } else {
            for (var i = 0; i < this.areaData.length; i++) {
              if (
                this.areaData[i].partnerareaguid ==
                this.$cookies.get("areaValue")
              ) {
                this.valueAr = this.$cookies.get("areaValue");
              } else {
                this.valueAr = this.areaData[0].partnerareaguid;
              }
            }
          }
          this.$cookies.set("areaValue", this.valueAr);
          this.$cookies.set(
            "dbMapCode",
            this.areaData[0].dbmapcountryregioncode
          );
          this.$cookies.set("nation", this.areaData[0].nation);
          //调用接口
          this.LoadUnBicycleList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    changeHandler() {
      // this.$cookies.set("areaValue", areaVal);
      this.$cookies.set("partner", this.valuePa);
      this.loadArea();
    },
    changeArea() {
      this.$cookies.set("areaValue", this.valueAr);
      this.LoadUnBicycleList();
    },
    userOperation(command) {
      switch (command) {
        case "logout":
          this.logout();
          break;
        case "editPsd":
          if (this.$cookies.get("LoginType") == "1") {
            this.$message.error(this.$t("message.marketNoPSD"));
            return;
          }
          this.formm.oldpsd = "";
          this.formm.newpsd = "";
          this.formm.surepsd = "";
          this.editPSDS = true;
          // console.log("编辑密码");
          break;
        case "editSecPsd":
          if (this.$cookies.get("LoginType") == "1") {
            this.$message.error(this.$t("message.marketNoSecPSD"));
            return;
          }
          this.formmSec.oldpsd = "";
          this.formmSec.newpsd = "";
          this.formmSec.surepsd = "";
          this.editSecPSDS = true;
          break;
      }
    },
    logout() {
      this.$cookies.set("SaveSiaLog", 2);
      this.$router.push("./login");
    },
    loadAgain() {
      this.loadPartner();
    },
    changeSecPsds() {
      if (this.formmSec.oldpsd == "") {
        this.$message.error(this.$t("message.oldSecPsdNo"));
        return;
      }
      if (this.formmSec.oldpsd != this.$cookies.get("saveSecond")) {
        this.$message.error(this.$t("message.psdNoOldPsd"));
        return;
      }
      if (this.formmSec.oldpsd.length < 6) {
        this.$message.error(this.$t("message.psdNolessBa"));
        return;
      }

      if (this.formmSec.newpsd == "") {
        this.$message.error(this.$t("message.newSecPsdNo"));
        return;
      }
      if (this.formmSec.newpsd.length < 6) {
        this.$message.error(this.$t("message.newSecNolessba"));
        return;
      }
      if (this.formmSec.newpsd != this.formmSec.surepsd) {
        this.$message.error(this.$t("message.surePsdNoNew"));
        return;
      }
      var randomNum = Math.random();
      var params = new URLSearchParams();
      params.append("loginName", this.$cookies.get("LoginName"));
      params.append("oldSecondPwd", this.formmSec.oldpsd);
      params.append("newSecondPwd", this.formmSec.newpsd);
      // params.append(
      //   "secretKey",
      //   md5(this.GLOBAL.timestamp.toString() + randomNum.toString())
      // );
      // params.append("randomNum", randomNum);
      params.append("partnerGuid", this.$cookies.get("partner"));

      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/PartnerRelated/updateSecondPwd",
        method: "post",
        data: params
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   },
        // withCredentials: true
      })
        .then(res => {
          // console.log(res);
          if (res.data.status == "success") {
            this.editSecPSDS = false;
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.$cookies.set("saveSecond", this.formmSec.newpsd);
            this.$cookies.set("SaveSiaLog", 2);
            // this.showTanS();
          } else {
            this.$message.error(res.data.message);
            this.$cookies.set("SaveSiaLog", 1);
            // this.showTanS();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    LoadUnBicycleList() {
      this.unlistData = [];
      this.unloading = true;
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerareaguid", this.$cookies.get("areaValue"));

      params.append("bicycleNo", "");
      params.append("OrderBys", OrderDesc);
      params.append("NoUseDays", this.bikeDay);
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/ElectricPowerCart/A_FEw_daYS_unuseD_EPc_LisT",
        method: "post",
        data: params
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   }
      })
        .then(res => {
          if (res.data.status == "success") {
            // console.log(res.data.data);
            this.unloading = false;
            this.unlistData = res.data.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    viewLog(val) {
      // window.open("http://mimacx.leanapp.cn/mimacxLog/" + val);
      window.open(
        "http://47.103.125.118:8089/VehicleLog/index.html#/?bicycle=" + val
      );
    },
    changePsds() {
      if (this.formm.oldpsd == "") {
        this.$message.error(this.$t("message.oldPSDNON"));
        return;
      }
      if (this.formm.oldpsd != this.$cookies.get("oldPassword")) {
        this.$message.error(this.$t("message.enternosame"));
        return;
      }
      // if (this.formm.oldpsd.length < 6) {
      //   this.$message.error(this.$t("message.oldPSDNSix"));
      //   return;
      // }

      if (this.formm.newpsd == "") {
        this.$message.error(this.$t("message.newPSDNON"));
        return;
      }
      // if (this.formm.newpsd.length < 6) {
      //   this.$message.error(this.$t("message.oldPSDNSix"));
      //   return;
      // }
      if (this.formm.newpsd != this.formm.surepsd) {
        this.$message.error(this.$t("message.psdNoSame"));
        return;
      }
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerareaguid", this.$cookies.get("areaValue"));

      params.append("loginName", this.$cookies.get("LoginName"));
      params.append("oldPwd", this.formm.oldpsd);
      params.append("newPwd", this.formm.newpsd);
      params.append("partnerGuid", this.$cookies.get("partner"));
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/PartnerRelated/EdiT_PaSsWoRd",
        method: "post",
        data: params
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   }
      })
        .then(res => {
          if (res.data.status == "success") {
            // console.log(res.data.data);
            this.editPSDS = false;
            this.$message({
              message: res.data.message,
              type: "success"
            });
            setTimeout(() => {
              this.$router.push("./login");
            }, 2000);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    showMap(coor, bike) {
      this.logBike = "";
      this.logBike = bike;
      if (marker != "") {
        marker.setMap(null);
      }
      var that = this;
      that.mapVb = true;
      var adCode = coor.split(",")[1] + "," + coor.split(",")[0];
      var code = "[" + coor.split(",")[1] + "," + coor.split(",")[0] + "]";
      that.currentWindow.visible = false;
      that.currentWindow.content = "";
      var geocoder = new AMap.Geocoder();
      setTimeout(() => {
        that.loadLayer("");
        geocoder.getAddress(adCode, function(status, result) {
          if (status === "complete" && result.regeocode) {
            var address = result.regeocode.formattedAddress;
            that.currentWindow.content =
              that.$t("message.bikeNo") + ":" + bike + "<br />" + address;
          }
        });
        that.currentWindow.position = JSON.parse(code);
        that.currentWindow.visible = true;
        that.AddMark(bike, coor.split(",")[1], coor.split(",")[0]);
      }, 500);
    },
    AddMark(BicycleNo, lon, lat) {
      var that = this;
      let map = amapManager.getMap();
      map.panTo([lon, lat]); //地图平移到指定位置
      var p = "[" + lon + "," + lat + "]";
      var extData = {};
      extData.BicycleNo = BicycleNo;
      extData.pos = lon + "," + lat;
      var icon = new AMap.Icon({
        image: require("../../assets/bicar.png"),
        imageSize: new AMap.Size(36, 36)
      });
      marker = new AMap.Marker({
        icon: icon,
        position: JSON.parse(p),
        draggable: true, //是否可拖动
        extData: extData,
        offset: new AMap.Pixel(-5, -5)
      });
      marker.on("click", function() {
        that.markerClick(this);
      });

      marker.setMap(map);
    },
    markerClick(e) {
      var that = this;
      that.currentWindow.visible = false;
      that.$nextTick(() => {
        that.currentWindow.visible = true;
      });
    },
    loadLayer(Optag) {
      var map = amapManager.getMap();
      map.clearMap(); // 清除地图覆盖物
      var params = new URLSearchParams();
      params.append("languagecode", this.$i18n.locale);
      params.append("timestamp", this.GLOBAL.timestamp);
      params.append(
        "securitykey",
        md5(this.GLOBAL.timestamp + this.GLOBAL.Maxs)
      );
      params.append("Token", this.$cookies.get("Token"));
      params.append("id", this.$cookies.get("ID"));
      params.append("partnerareaguid", this.$cookies.get("areaValue"));
      params.append("Optag", Optag);
      params.append("PNO", this.$cookies.get("partner"));
      params.append("DbMapCountryRegionCode", this.$cookies.get("dbMapCode"));
      params.append("Nation", this.$cookies.get("nation"));

      params.append("loginType", this.$cookies.get("LoginType"));
      params.append("pwd", this.$cookies.get("pwd"));
      this.$axios({
        url: "/ElectronicFence/SHow_Electronic_fence",
        method: "post",
        data: params
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded"
        //   }
      })
        .then(res => {
          if (res.data.status == "success") {
            // console.log(res.data.data);
            var data = res.data.data[0];
            if (data != null) {
              for (var i = 0; i < data.length; i++) {
                if (data[i].Type == 3 || data[i].Type == 5) {
                  this.AddLayer(
                    data[i].GUID,
                    data[i].SOMEINFO,
                    data[i].ZB,
                    data[i].Type
                  );
                }
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    AddLayer(guid, name, point, LayerType) {
      var bubble = false;
      if (LayerType == "3") {
        bubble = true;
      }

      var color = "#0D9BF2";
      if (LayerType == "5") {
        color = "#E27326";
      }

      var extData = {};
      extData.Guid = guid;
      extData.Name = name;
      var p = "[" + point + "]";
      var path = JSON.parse(p);
      var polygon = new AMap.Polygon({
        path: path, //设置多边形边界路径
        strokeColor: color, //线颜色
        strokeOpacity: 0.3, //线透明度
        strokeWeight: 8, //线宽
        fillColor: color, //填充色
        fillOpacity: 0.3, //填充透明度
        extData: extData,
        bubble: bubble
      });
      let map = amapManager.getMap();
      polygon.setMap(map);
    },
    searchUnList() {
      if (this.bikeDay == "") {
        this.$message.error(this.$t("message.enterDay"));
        return;
      }
      if (this.GLOBAL.IntRegst.test(this.bikeDay) === false) {
        this.$message.error(this.$t("message.enterDay"));
        return;
      }
      this.LoadUnBicycleList();
    }
  },
  components: {
    SelectMenu,
    SelectMen,
    LangSelect
  }
};
</script>
<style>
.unBListheader {
  height: 64px;
  background: #000;
}
.unBListsel {
  float: right;
  color: #fff;
  padding-top: 12px;
}
.unBListmain {
  padding: 10px;
}
.unBLHead {
  height: 50px;
  line-height: 50px;
  width: 98%;
  background-color: #ffffff;
  padding: 0 10px;
}
.unlistIn {
  width: 183px !important;
}

.maps {
  width: 100%;
  height: 460px;
}

.logBtn {
  position: absolute;
  top: 118px;
  right: 42px;
  z-index: 100;
}
</style>
